import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
import { List } from 'immutable';
import { KomitentView } from 'src/app/lookups/komitent/komitent-view';
import { BaseDataService, BaseModalUpdateComponent, ModalContainerService, ModalService, QueryParameter } from 'yt-ng-framework';
import { EkranskaKarticaKomitenata } from './ekranska-kartica-komitenata';
import { EkranskaKarticaKomitenataUpdateComponent } from './ekranska-kartica-komitenata-update.component';
import { EkranskaKarticaKomitenataComponent } from './ekranska-kartica-komitenata.component';
import { TekuceEkranskiPregledKomitenata } from './tekuce-ekranski-pregled-komitenata';

@Component({
  selector: 'app-ekranska-kartica-komitenata-modal',
  templateUrl: './ekranska-kartica-komitenata-modal.component.html'
})
export class EkranskaKarticaKomitenataModalComponent extends BaseModalUpdateComponent<TekuceEkranskiPregledKomitenata> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<TekuceEkranskiPregledKomitenata>,
    protected baseDataService: BaseDataService,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) {
    super(modalContainerService, activeModal, modalService);
  }


  Komitent;
  dateTo;
  dateFrom;
  @ViewChild('baseUpdate', { static: true }) BaseUpdate: EkranskaKarticaKomitenataUpdateComponent;

  ngOnInit() {
    this.baseDataService.GetByID('Komitent', this.baseUpdateComponent.Item.ID, KomitentView)
      .subscribe(item => {
        this.Komitent = item.SNaziv;
      })

    // this.dateTo = this.BaseUpdate.filterValues.filter.dateFrom;

    //let doDatuma = this.BaseUpdate.dateFrom;

  }

  Print() {
    this.BaseUpdate.Print();
  }




}
